import {Pipe, PipeTransform} from '@angular/core';
import {AnzahlProKategorie} from '../dtos/cockpit-kontrolle/pruefung-der-variablen';

@Pipe({
  name: 'retrievevalueByIndex',
  standalone: false
})
export class RetrievevalueByIndexPipe implements PipeTransform {
  transform(colIndex: number | string, arr: AnzahlProKategorie[]): number {
    if (typeof colIndex === 'string') {
      colIndex = Number(colIndex);
    }
    return this.retrievevalueByIndeOf(colIndex, arr);
  }

  retrievevalueByIndeOf(colIndex: number, arr: AnzahlProKategorie[]): number {
    const kategorie = colIndex.toString();
    if (arr.some(ak => ak.Kategorie === kategorie)) {
      const idx = arr.findIndex(ak => ak.Kategorie === kategorie);
      return arr[idx]?.Anzahl;
    }
    return 0;
  }
}
